namespace Matrix {
    @Serenity.Decorators.registerClass('Matrix.Administration.AboutDialog')
    export class AboutDialog extends Serenity.TemplatedDialog<AboutResponse> {
        constructor(opt: AboutResponse) {
            super(opt);

            this.dialogTitle = "About";
        }

        static execute(): void {
            Administration.AboutService.About({
            },
                response => {
                    var dlg = new AboutDialog(response);
                    dlg.dialogOpen();
                });
        }

        getDialogOptions() {
            var opt = super.getDialogOptions();
            opt.width = 500;
            return opt;
        }

        getTemplate() {
            var o = this.options;
            var dependencies = (o.Dependencies == null || !Object.keys(o.Dependencies).length) ? "N/A" :
                Object.keys(o.Dependencies).map(key => {
                    var ver = o.Dependencies[key];
                    var name = key;
                    if (Q.startsWith(name, "mx-matrix-"))
                        name = name.substr("mx-matrix-".length);
                    else if (Q.startsWith(name, "mx-"))
                        name = name.substr("mx-".length);

                    name = titleize(name);

                    return Q.htmlEncode(name) + ": " + Q.htmlEncode(ver);
                }).join(", ");

            return `<div style="background-color: var(--body-bg); color: white; padding: 10px 10px;">
<div style="background-image:url(${Q.resolveUrl("~/Content/site/images/mx-logo-transparent-bg.png")});
height: 100px; background-size: 70%; 
background-repeat: no-repeat; background-position: center center">
</div>
<h4><b style="color: #e2a550">Matrix Web Portal</b></h4>
<p style="font-size: 14px">
   <b>Version: </b> ${Q.htmlEncode(o.Version)}
</p>
<p>
   <b>Dependencies: </b> ${dependencies}
</p>
<p>
   <b>Database: </b> ${Q.htmlEncode(o.DatabaseName)},
   <b>User: </b> ${Q.htmlEncode(o.DatabaseUser)}
</p>
<p>
   <b>Environment: </b> ${Q.htmlEncode(o.Environment)}
</p>
<p>
   <b>Installed Modules: </b> ${Q.htmlEncode((o.InstalledModules || []).join(', '))}
</p>
<p>
   <b>User Roles: </b> ${Q.htmlEncode((o.UserRoles || []).join(', '))}
</p>
</div>`;
        }
    }
}